<template>
  <div class="bg-white !shadow rounded-md py-2 px-3 text-lg">
    <div class="text-xl font-bold mb-3">Outbound</div>
    <div class="space-y-3 text-lg mb-3"
      v-if="existsTripData">
      <HighlightChange class="flex flex-row items-center gap-3"
        :changeType="tripHighlighting.vehicleCode">
        <div v-if="showRouteDetailModal">
          <RouteDetailModal
            :routeId="tripData.route_id"
            :title="`${tripData.vehicle_code} - Outbound - ${tripData.pickup_building?.name}`"
            :date="selectedDate"
            direction="Outbound"
          />
        </div>
        <div class="font-bold">
          Vehicle Number
        </div>
        <div v-if="tripData.vehicle_code">
          <span class="text-gray-600">{{ tripData.vehicle_code }}</span>
        </div>
        <div v-else>
          <span class="text-gray-300">---</span>
        </div>
      </HighlightChange>
      <HighlightChange class="flex flex-row items-center gap-3"
        :changeType="tripHighlighting.departureTime">
        <div class="font-bold">
          Depart Time
        </div>
        <div v-if="tripData.departure_time">
          <span>{{ departureTimeDisplay }}</span>
        </div>
        <div v-else>
          <span class="text-gray-300">---</span>
        </div>
      </HighlightChange>
      <HighlightChange class="flex flex-row gap-3"
        :changeType="tripHighlighting.dropoffTime">
        <div class="font-bold">
          Dropoff Time
        </div>
        <div v-if="tripData.dropoff_time">
          <span>{{ dropoffTimeDisplay }}</span>
        </div>
        <div v-else>
          <span class="text-gray-300">---</span>
        </div>
      </HighlightChange>
      <div class="flex flex-row items-center gap-3">
        <div v-if="overrideDropoffBuilding">
          <HighlightChange
            :changeType="tripHighlighting.overrideDropoffBuildingDiff">
            <BuildingDisplay
              :buildingData="overrideDropoffBuilding"
              :buildingDataDiff="overrideDropoffBuildingDiff"
            />
          </HighlightChange>
        </div>
        <div v-else>
          <div v-if="tripData.dropoff_bus_stop">
            <HighlightChange
              :changeType="tripHighlighting.dropoffBusStop">
              <BusStopDisplay
                :busStopData="tripData.dropoff_bus_stop"
              />
            </HighlightChange>
          </div>
          <div v-else>
            <HighlightChange
              :changeType="tripHighlighting.dropoffAddress">
              <AddressDisplay
                type="dropoff"
                :addressData="tripData.dropoff_address"
              />
            </HighlightChange>
          </div>
        </div>
      </div>
      <div class="flex flex-col bg-gray-100 rounded-md items-start p-1 gap-1">
        <HighlightChange class="flex flex-row gap-3"
          :changeType="tripHighlighting.tripPickupBuilding">
          <BuildingDisplay
            type="pickup"
            :buildingData="tripData.trip_pickup_building"
            :buildingDataDiff="tripDataDiff?.trip_pickup_building"
          />
        </HighlightChange>
      </div>
    </div>
    <div class="space-y-3 text-lg mb-3"
      v-if="!existsTripData">
      None
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import time from '../../../../services/utils/time.js'
import scheduleUtil from '../../../../services/utils/schedule.js'

import BusStopDisplay from '../BusStopDisplay.vue'
import BuildingDisplay from '../BuildingDisplay.vue'
import AddressDisplay from '../AddressDisplay.vue'

import HighlightChange from '../../utilities/HighlightChange.vue'

import RouteDetailModal from '../../../modals/RouteDetailModal.vue'


export default {
  components: {
    BusStopDisplay,
    BuildingDisplay,
    AddressDisplay,
    HighlightChange,
    RouteDetailModal,
  },
  props: {
    showRouteDetailModal: {
      type: Boolean,
      default: false,
    },
    tripData: Object,
    tripDataDiff: Object,
    overrideDropoffBuilding: {
      type: Object,
      default: undefined,
    },
    overrideDropoffBuildingDiff: {
      type: Object,
      default: undefined,
    },
    selectedDate: String,
  },
  computed: {
    existsTripData() {
      return !(this.tripData == undefined || isEmpty(this.tripData))
    },
    departureTimeDisplay() {
      return time.formatAMPM(this.tripData?.departure_time)
    },
    dropoffTimeDisplay() {
      return time.formatAMPM(this.tripData?.dropoff_time)
    },
    tripHighlighting() {
      return {
        vehicleCode: scheduleUtil.mapDiffObject(this.tripDataDiff?.vehicle_code),
        departureTime: scheduleUtil.mapDiffObject(this.tripDataDiff?.departure_time),
        dropoffTime: scheduleUtil.mapDiffObject(this.tripDataDiff?.dropoff_time),
        dropoffBusStop: scheduleUtil.mapDiffObject(this.tripDataDiff?.dropoff_bus_stop),
        dropoffAddress: scheduleUtil.mapDiffObject(this.tripDataDiff?.dropoff_address),
        tripPickupBuilding: scheduleUtil.mapDiffObject(this.tripDataDiff?.trip_pickup_building),
        overrideDropoffBuildingDiff: scheduleUtil.mapDiffObject(this.overrideDropoffBuildingDiff),
      }
    },
  },
}
</script>
